const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchTableData = async (tableName) => {
    try {
        const response = await fetch(`${API_BASE_URL}/${tableName}`);
        if (!response.ok) throw new Error('Network response was not ok');
        return await response.json();
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const fetchDateRangeData = async (tableName, startDate, endDate) => {
    try {
        const response = await fetch(
            `${API_BASE_URL}/${tableName}/daterange?startDate=${startDate}&endDate=${endDate}`
        );
        if (!response.ok) throw new Error('Network response was not ok');
        return await response.json();
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};
